import React from "react";
import { useSelector } from "react-redux";

import {
    selectModelingOpen,
    setModelingOpen as setModelingOpenAction,
    selectModelingSelectedRole,
} from "../../../reducers/reports-modeling/roleLevelSlice";

import useReduxValue from "../../common/hooks/useReduxValue";

import ReportModelingBox from "../report-modeling-box";

import RoleLevelSingleRoleModelingBox from "./role-level-role-modeling-box.jsx";
import RoleLevelGroupRoleModelingBox from "./role-level-group-role-modeling-box.jsx";

const RoleLevelModelingBox = () => {
    const [modelingOpen, setModelingOpen] = useReduxValue(selectModelingOpen, setModelingOpenAction);
    const selectedRole = useSelector(selectModelingSelectedRole);
    const selectedRoleId = useSelector((state) => state.reportsModeling.roleLevel.modeling.selectedRoleId);
    const showRoleModelingBox = selectedRole && !selectedRole.isComplex && selectedRole.initialized;

    return (
        <ReportModelingBox open={modelingOpen} onOpenClick={() => setModelingOpen(!modelingOpen)}>
            <RoleLevelGroupRoleModelingBox selectedRole={selectedRole} />

            {showRoleModelingBox && <RoleLevelSingleRoleModelingBox selectedRoleId={selectedRoleId} selectedRole={selectedRole} />}
        </ReportModelingBox>
    );
};

export default RoleLevelModelingBox;
